import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { DocumentContainerComponent } from "./containers/document-container/document-container.component";

const routes: Routes = [
  { path: "", component: DocumentContainerComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GenericDocumentRoutingModule {}
